import axios, { AxiosError } from 'axios';

export type SizeList = {
	id: string;
	title: string;
}[];

/** Апи получения списка типов разделки */
export const getSizes = async () => {
	try {
		const { data } = await axios.get<SizeList>(`${process.env.HOST}/api_v1/sizes/`);
		return data;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.error(error.response?.data);
		} else {
			console.error(error);
		}
	}
};
